import {
  HttpErrorResponse,
  HttpInterceptor,
  HttpRequest,
  HttpEvent,
  HttpHandler
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { GraphqlRequestError } from '../../cms/cms-shared/services/graphql/graphql.models';

import { ErrorsModelsTransformer } from './errors.models.transformer';


@Injectable()
export class EcommerceRequestInterceptor implements HttpInterceptor {

  public intercept(request: HttpRequest<Record<string, unknown>>, next: HttpHandler): Observable<HttpEvent<Record<string, unknown>>> {
    return next.handle(request).pipe(
      catchError((error) => {
        return this.processError(error);
      })
    );
  }

  public processError(error: HttpErrorResponse | unknown): Observable<never> {
    if (error instanceof HttpErrorResponse) {
      const isGraphRequest = error.url && error.url.endsWith('/graphql');
      if (isGraphRequest && error.status === 400) {
        return throwError({
          message: error.error?.message ?? 'Network error',
          networkError: error.error,
          graphQLErrors: []
        } as GraphqlRequestError);
      }


      /**
       * TODO: For now we are assuming that any REST error is an ecommerce one,
       * that is not always true because we have our own REST API. We should handle
       * these errors separately.
       */
      const ecommerceError = ErrorsModelsTransformer.ecommerceErrorFromApi(error);

      return throwError(ecommerceError);
    }

    return throwError(error);
  }

}
